module.exports = __webpack_public_path__ + "static/img/phone2@2x.9914a41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xiazia/phone2@2x.png
// module id = hQ3A
// module chunks = 0